module.exports = __webpack_public_path__ + "img/array3.7a249a13.png";